export function getCurrentTimezoneName() {
    return new Intl.DateTimeFormat('en-US', { timeZoneName: 'long' })
        .formatToParts(new Date())
        .find(x => x.type === 'timeZoneName').value;
}
